import { useTheme, Stack } from '@mui/material';
import useFeature from 'services/hooks/feature';
import { GenreSelectorProps } from '../types';
import MicroGenreUpgradeMessage from './MicroGenreUpgradeMessage';
import MicroGenreSelector from './MicroGenreSelector';

const MicroGenreSelectorContainer = ({
  value,
  onChange,
}: GenreSelectorProps) => {
  const theme = useTheme();

  const { isMicroGenrePaywallEnabled } = useFeature();

  return (
    <Stack gap={theme.spacing(2)}>
      <MicroGenreSelector
        value={value}
        onChange={onChange}
        disabled={isMicroGenrePaywallEnabled}
      />
      {isMicroGenrePaywallEnabled && <MicroGenreUpgradeMessage />}
    </Stack>
  );
};

export default MicroGenreSelectorContainer;
